import 'core-js/stage/3';
import 'regenerator-runtime/runtime';
import 'intersection-observer';
import 'isomorphic-fetch'; // d3
import 'mdn-polyfills/Node.prototype.append'; // d3
import smoothscroll from 'smoothscroll-polyfill';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import Storage from 'vue-ls';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from '@/i18n';
import './filters';
import { VBreakpoint } from '@/components/common/VBreakpoint.js';

import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-vue/src/index.scss';
import '@/styles/base.scss';

// Bootstrap Components
import {
    AlertPlugin,
    ButtonPlugin,
    CardPlugin,
    CollapsePlugin,
    CarouselPlugin,
    TabsPlugin,
    TablePlugin,
} from 'bootstrap-vue';

// Base components
import Icon from '@/components/common/Icon';

smoothscroll.polyfill();

// Sync router with store
sync(store, router);

Vue.use(AlertPlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(CollapsePlugin);
Vue.use(CarouselPlugin);
Vue.use(TabsPlugin);
Vue.use(TablePlugin);

Vue.use(Storage, {
    namespace: 'onlineassetmanagement__',
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'session', // storage name session, local, memory
});

Vue.component('Icon', Icon);
Vue.component('VBreakpoint', VBreakpoint);

Vue.config.productionTip = false;

// Google Tag Manager
(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-WNVCJXK');
// End Google Tag Manager

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
